import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import './NavMenu.css';
import logoC from '../img/logo-c.png';


class NavMenu extends Component {
  static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }


    handleClick(event) {
        event.preventDefault();
        let path = '';
        switch (event.target.id) {

            case 'homeBtn':
                path = '/';
                this.props.history.replace(path);
                break;
            case 'aboutBtn':
                path = '/about';
                this.props.history.replace(path);
                break;
            case 'valuedcustomersBtn':
                path = '/valued-customers';
                this.props.history.replace(path);
                break;
            case 'customAppsBtn':
                path = '/custom-applications';
                this.props.history.replace(path);
                break;
            case 'techSuppBtn':
                path = '/technology-support';
                this.props.history.replace(path);
                break;
            case 'BusContBtn':
                path = '/business-continuity';
                this.props.history.replace(path);
                break;
            case 'techTalkBtn':
                path = 'tech-talk';
                this.props.history.replace(path);
                break;
            case 'contactBtn':
                path = '/contact-us';
                this.props.history.replace(path);
                break;
            case 'networkAuditBtn':
                path = '/it-support-network-audit';
                this.props.history.replace(path);
                break;
            default:
                break;
        }
    }

  render () {
    return (
        <nav className="navbar navbar-default navbar-fixed-top">
            <div className="container-fluid">
                <div className="navbar-header">
                    <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
                        <span className="sr-only">Toggle navigation</span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                    </button>
                    <a id="homeBtn" onClick={this.handleClick}><img id="homeBtn" onClick={this.handleClick} src={logoC} className="img-responsive rcenter logo" alt="" /></a>
                </div>

                <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">


                    <ul className="nav navbar-nav navbar-right">

                        <li><a id="homeBtn" onClick={this.handleClick}>HOME</a></li>
                        <li className="dropdown"><a href="#" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">SERVICES<span className="caret"></span></a>
                            <ul className="dropdown-menu">
                                <li><a id="customAppsBtn" onClick={this.handleClick}>Custom Applications</a></li>
                                <li><a id="techSuppBtn" onClick={this.handleClick}>Technology Support</a></li>
                                <li><a id="BusContBtn" onClick={this.handleClick}>Business Continuity</a></li>
                                <li><a id="networkAuditBtn" onClick={this.handleClick}>IT Support Network Audit</a></li>
                            </ul>
                        </li>
                        <li><a id="aboutBtn" onClick={this.handleClick}>ABOUT</a></li>
                        <li><a id="valuedcustomersBtn" onClick={this.handleClick}>VALUED CUSTOMERS</a></li>
                        <li><a id="techTalkBtn" onClick={this.handleClick}>TECH TALK</a></li>
                        <li><a id="contactBtn" onClick={this.handleClick}>CONTACT</a></li>
                        <li><a href="http://projectmanager.customapps.net" className="clientPortalBtn" target="_blank" rel="noopener noreferrer">CLIENT PORTAL</a> </li>

                    </ul>
                </div>
            </div>
        </nav>
    );
  }
}

export default withRouter(NavMenu);


// WEBPACK FOOTER //
// ./src/components/NavMenu.js